import React from 'react';

import { generateClient } from 'aws-amplify/api';

import { ChatMessageItem } from '../../graphql/API';
import { onVenueReceiveChatMessageFromAdmin } from '../../graphql/subscriptions';
import { processGqlResult } from '../../utils/gql-utils';

const client = generateClient();

type Props = {
  userId?: string;
};

export const useChatMessageListenerQuery = ({ userId }: Props) => {
  const [message, setMessage] = React.useState<Nullable<ChatMessageItem>>(null);

  React.useEffect(() => {
    const createSub = client.graphql({
      query: onVenueReceiveChatMessageFromAdmin,
      variables: { userType: 'venue', toUserId: userId as string },
    }).subscribe({
      next: ({ data }: { data: { onVenueReceiveChatMessageFromAdmin: ChatMessageItem } }) => {
        const _message = processGqlResult<ChatMessageItem>(
          'onVenueReceiveChatMessageFromAdmin',
          { data },
        );
        setMessage(_message as ChatMessageItem);
      },
      error: (error) => {
        console.warn(error);
      },
    });

    return () => {
      createSub.unsubscribe();
    };
  }, [setMessage, userId]);

  return {
    message,
  };
};
